import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {TextBuiltInControl} from '../TextBuiltInControl';

export abstract class TextVisibilityBuiltInControl extends TextBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes.GENERAL.HIDDEN_NODE;
  }
}
